"use client";

import { createContext, PropsWithChildren, useContext, useState } from "react";

export type ArticleAudio = {
  articleId: string;
  title: string;
  audioUrl: string;
  articleUrl: string;
  imageUrl?: string;
};

type ArticleAudioContextType = {
  audio: ArticleAudio | null;
  openArticleAudio: (audio: ArticleAudio) => void;
  closeArticleAudio: () => void;
};

export const ArticleAudioContext = createContext<ArticleAudioContextType>({
  audio: null,
  openArticleAudio: () => null,
  closeArticleAudio: () => null,
});

export const ArticleAudioContextProvider = ({ children }: PropsWithChildren) => {
  const [audio, setAudio] = useState<ArticleAudio | null>(null);

  return (
    <ArticleAudioContext.Provider
      value={{
        audio,
        openArticleAudio: (audio) => setAudio(audio),
        closeArticleAudio: () => setAudio(null),
      }}
    >
      {children}
    </ArticleAudioContext.Provider>
  );
};

export const useArticleAudio = () => {
  const { audio, openArticleAudio, closeArticleAudio } = useContext(
    ArticleAudioContext,
  );

  return { audio, openArticleAudio, closeArticleAudio };
};
